import { Component, signal } from '@angular/core';

interface FaqItem {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-faq',
  imports: [],
  templateUrl: './faq.html',
  styleUrl: './faq.css',
})
export class Faq {
  readonly items: FaqItem[] = [
    {
      question: 'How i can receive orders?',
      answer:
        "Once your store is registered and approved on OrderYaa, customer orders land straight in your store dashboard in real time. You'll get an instant notification for every new order with the items, delivery address, and payment status, so you can start preparing right away. From the same dashboard you can accept or reject an order, update its status as it moves through preparation, and hand it off to a rider for delivery, or mark it ready for pickup if the customer is collecting it themselves.",
    },
    {
      question: 'Are there any cost if i register on site?',
      answer:
        "Registering your store on OrderYaa is completely free — there's no sign-up fee and no monthly subscription. We only take a small commission on orders you actually complete, so you only pay when you're making sales. There are no hidden charges for listing your products, updating your menu, or using the dashboard, and you can pause or close your store at any time without any penalty or cancellation fee.",
    },
    {
      question: 'What are the opening hours?',
      answer:
        "You're in full control of that — each store sets its own opening and closing hours from the OrderYaa dashboard. Customers can only place orders during the hours you've set, and you can update them anytime as your schedule changes. You can also set different hours for different days of the week, add temporary closures for holidays or maintenance, and the storefront will automatically show as closed to customers outside those windows.",
    },
  ];

  readonly openIndex = signal<number | null>(2);

  toggle(index: number): void {
    this.openIndex.set(this.openIndex() === index ? null : index);
  }
}
